import { render, staticRenderFns } from "./detailRelevancyService.vue?vue&type=template&id=1cbe2cf8&scoped=true&"
import script from "./detailRelevancyService.vue?vue&type=script&lang=js&"
export * from "./detailRelevancyService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe2cf8",
  null
  
)

export default component.exports